import { Badge } from "@/components/ui/badge";

interface ServiceDetailsProps {
  service: {
    name: string;
    description: string;
    service_mode?: string;
    instant_booking?: boolean;
    duration?: number;
    duration_unit?: string;
    service_area?: string;
    requires_scheduling?: boolean;
  };
  businessName?: string;
  currency?: string | null;
  variant?: 'compact' | 'detailed';
}

export const ServiceDetails = ({
  service,
  businessName,
  currency,
  variant = 'compact'
}: ServiceDetailsProps) => {
  const hasDuration = service.duration && service.duration > 0;
  const displayDuration = hasDuration 
    ? `${service.duration} ${service.duration_unit || 'minutes'}${service.duration > 1 && service.duration_unit === 'hour' ? 's' : ''}`
    : null;
  
  if (variant === 'compact') {
    return (
      <div className="grow overflow-hidden">
        <h3 className="text-lg font-medium truncate">{service.name}</h3>
      </div>
    );
  }
  
  // Detailed view for service detail dialog
  return (
    <div className="mb-4">
      <div className="flex items-start justify-between">
        <div>
          <h2 className="text-xl font-semibold">{service.name}</h2>
        </div>
        
        <div className="flex items-center space-x-2">
          {service.instant_booking && (
            <Badge className="bg-green-100 text-green-800 hover:bg-green-200">
              Instant Booking
            </Badge>
          )}
          
          {service.service_mode === 'in_person' && (
            <Badge className="bg-blue-100 text-blue-800 hover:bg-blue-200">
              In Person
            </Badge>
          )}
          
          {service.service_mode === 'online' && (
            <Badge className="bg-purple-100 text-purple-800 hover:bg-purple-200">
              Online
            </Badge>
          )}
          
          {service.service_mode === 'client-location' && (
            <Badge className="bg-amber-100 text-amber-800 hover:bg-amber-200">
              At Your Location
            </Badge>
          )}
          
          {service.service_mode === 'my-location' && (
            <Badge className="bg-amber-100 text-amber-800 hover:bg-amber-200">
              At Provider's Location
            </Badge>
          )}
        </div>
      </div>
      
      {displayDuration && (
        <div className="mt-2 text-sm text-gray-700">
          <span className="font-medium">Duration:</span> {displayDuration}
        </div>
      )}
      
      {service.description && (
        <div className="mt-4">
          <p className="text-gray-700 whitespace-pre-line">{service.description}</p>
        </div>
      )}
    </div>
  );
};
